export default {
  companyAdaptationMetadata: {
    titles: {
      adaptationPlans: 'Adaptation plans',
      assignAdaptation: 'Assignment of adaptation plans',
      exportAdaptation: 'Export adaptation results to excel file',
      settings: 'Managing adaptation plans',
      createPlan: 'New plan',
      editPlan: 'Edit the name of the adaptation',
      copyPlan: 'Copy into other company',
      createTask: 'New task',
      editTask: 'Edit the task',
      selectEmployees: 'Select employees',
      selectMentors: 'Select mentors',
      changeDeadline: 'Change a deadline for assigned adaptation',
    },
    descriptions: {
      adaptationPlans:
        'To start working with the adaptation plan, an employee needs to connect HR-Buddy_bot. You can do this on the platform or by clicking on the link from the letter that you will receive users when assigning an adaptation plan.',
      editPlan:
        'The name of the adaptation plan will be changed for plans already assigned to employees',
      copyPlan: 'Select company or companies for copy the adaptation plan into them',
    },
    buttons: {
      assignPlan: 'Assign a plan',
      createPlan: 'Create a plan',
      deletePlan: 'Delete the plan',
      createTask: 'Add a task',
      moveUp: 'Move up',
      moveDown: 'Move down',
      managingPlans: 'Managing plans',
      addPlan: 'Add an adaptation plan',
      removePlan: 'Remove the adaptation plan',
    },
    tooltips: {
      refresh: 'Refresh the list',
      day: 'Specify the number of the day on which the employee should receive this task. The number of the day from the date the plan was assigned to the employee. For example, if you want an employee to receive a task on day 3 after assigning him a plan, put the number 3. Weekends (Sat and Sun) are skipped.',
      image:
        'You can attach one image to the task, it will be displayed before the task description. Image weight limit: no more than 5 Mb.',
      file: 'You can attach one file to the task. File weight limit: no more than 5 Mb.',
    },
    placeholders: {
      selectPlan: 'Select a plan',
      enterUserName: 'Enter user full name',
    },
    assignMenu: {
      internal: 'to a company employee',
      external: 'to an external user',
    },
    menuSettings: {
      editPlan: 'Edit the name of the plan',
      copyPlan: 'Copy the adaptation plan',
      copyPlanTo: 'Copy the plan to another company',
    },
    statuses: {
      all: 'All',
      completed: 'Completed',
      notCompleted: 'Not completed',
    },
    tableHeaders: {
      planName: 'Plan name',
      dateStart: 'Start date',
      dateFrom: 'from',
      dateTo: 'to',
      participant: 'Participant',
      mentor: 'Mentor',
      team: 'Team',
      deadline: 'Deadline',
      progress: 'Progress',
      statistics: 'Statistics',
    },
    stubs: {
      noPlans: "You haven't added any plans yet",
      noTasks: "You haven't added any tasks yet",
      noEmployees: 'To assign a plan, add employees to the company. To do this, go to the tab',
      noAssignedPlans:
        "You haven't assigned any plans yet, create a new plan in the «Managing plans» section",
    },
    // messages
    successMessages: {
      createPlan: 'The plan was successfully created',
      editPlan: 'The plan was successfully edited',
      copyPlan: 'The plan successfully copied',
      deletePlan: 'The plan successfully deleted',
      createTask: 'The task was successfully created',
      editTask: 'The task was successfully edited',
      swapTasks: 'The tasks successfully swapped',
      deleteTask: 'The task successfully deleted',
      removeDeadline: 'The deadline successfully removed',
      setDeadline: 'The deadline successfully set',
      assignAdaptation: 'Adaptation plans have been successfully assigned',
      deleteAdaptations: 'The assigned adaptation plans successfully deleted',
    },
    errorMessages: {
      createPlan: 'Failed to create a plan',
      editPlan: 'Failed to edit the plan',
      copyPlan: 'Failed to copy the plan',
      exportPlan: 'Failed to export the plan',
      deletePlan: 'Failed to delete the plan',
      createTask: 'Failed to create a task',
      editTask: 'Failed to edit a task',
      swapTasks: 'Failed to swap the tasks',
      deleteTask: 'Failed to delete the task',
      removeDeadline: 'Failure to remove the deadline',
      setDeadline: 'Failure to set the deadline',
      assignAdaptation: 'Failed to assign adaptation plans',
      deleteAdaptations: 'Failed to delete the assigned adaptation plans',
      exportAdaptation: {
        default: 'Failed to generate file',
        timeoutExpired: 'Too much data. Please shorten the period and repeat again.',
      },
    },
    // confirm dialogs
    confirmDeleteAdaptations: {
      title: 'Delete the assigned adaptation plan?',
      text: 'Deleted assigned adaptation plans cannot be restored. Are you sure?',
    },
    confirmDeleteTask: {
      title: 'Delete the task?',
      text: 'The task will be removed from the plan',
    },
    confirmDeletePlan: {
      title: 'Delete the plan?',
      text: 'This will delete the current adaptation plan, all its tasks and all assigned adaptations for this plan.',
    },
  },
};
